import type { TripDto } from '../api/trips.js';
import { Avatar } from './Avatar.js';

interface Props {
  driver: NonNullable<TripDto['driver']>;
}

function Star({ filled }: { filled: boolean }) {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill={filled ? '#FACC15' : 'none'} aria-hidden="true">
      <path
        d="M8 1.5l1.96 4.13 4.54.46-3.4 3.07.94 4.44L8 11.42 3.96 13.6l.94-4.44L1.5 6.09l4.54-.46L8 1.5z"
        stroke={filled ? '#FACC15' : '#D1D5DB'}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DriverCard({ driver }: Props) {
  return (
    <div className="flex items-center gap-3">
      <Avatar name={driver.name} size={48} />
      <div className="flex-1">
        <div className="flex items-center justify-between gap-2">
          <p className="font-display text-base font-semibold leading-tight">{driver.name}</p>
          <span className="num inline-flex items-center gap-1 text-sm font-semibold">
            <Star filled />
            {driver.rating.toFixed(1)}
          </span>
        </div>
        {driver.vehicle ? (
          <p className="text-xs text-muted">
            {driver.vehicle.color} {driver.vehicle.make} {driver.vehicle.model}
            <span className="ml-2 rounded-md bg-line/70 px-1.5 py-0.5 font-semibold tracking-wider text-ink">
              {driver.vehicle.plate}
            </span>
          </p>
        ) : null}
      </div>
    </div>
  );
}
